import CrudRepository from './CrudRepository'
export default class ReserveRepositiory extends CrudRepository {
  constructor () {
    super('core/api/numberReservations/reserve')
  }
}
